module.exports = __webpack_public_path__ + "img/s14402.32ed6b07.webp";